class HomeHeader {

  constructor(){
		this.trigger  = document.querySelectorAll(`[data-trigger="home-header"]`);

		if(this.trigger){
			this._init();
		}
	}

	_init(){
		for (let element of this.trigger) {
			element.addEventListener('click', ()=> this.validateForms(element));
		}
	}

	validateForms(element) {
		const attrType = element.getAttribute('data-type');
		if(document.querySelector(`[data-target="home-header-${attrType}"]`).value !== '') {
			document.location.href = document.querySelector(`[data-target="home-header-${attrType}"]`).value;
		}
	}
}
  
export let homeHeader = new HomeHeader();